import axios from 'axios';

const MAX_RETRIES = 5;
const RETRY_DELAY_MS = 250;

function handleAlgoIndexerRequest(url, options, retries = 0) {
  return axios(url, options).catch((error) => {
    if (error.response && error.response.status === 429 && retries < MAX_RETRIES) {
      const delay = RETRY_DELAY_MS * Math.pow(2, retries);
      console.log(`Received 429 error, retrying in ${delay} ms...`);
      return new Promise((resolve) => setTimeout(resolve, delay)).then(() => handleAlgoIndexerRequest(url, options, retries + 1));
    } else {
      throw error;
    }
  });
}

async function getMetadata(assetId, asArray = false) {
  // Fetch `acfg` transactions.
  const url = `https://mainnet-idx.algonode.cloud/v2/transactions?asset-id=${assetId}&tx-type=acfg`;
  let transactions = [];

  try {
    const { data } = await handleAlgoIndexerRequest(url);
    transactions = data.transactions;
  } catch (err) {
    return null;
  }

  // Sort the most recent `acfg` transactions first.
  transactions.sort((a, b) => b['round-time'] - a['round-time']);

  // Attempt to parse each `acf` transaction's note for ARC69 metadata.

  const metadata = transactions
    .map((tx) => {
      try {
        const noteBase64 = tx.note;
        const noteString = atob(noteBase64)
          .trim()
          .replace(/[^ -~]+/g, '');
        const noteObject = JSON.parse(noteString);
        if (noteObject.standard === 'arc69') {
          return noteObject;
        }
      } catch (err) {
        // Oh well...
      }
    })
    .filter((it) => it);

  console.log({ metadata });

  return asArray ? metadata : metadata[0];
}

export default getMetadata;
